export const togglePopoutComposer = value => ({
  key: 'toggle-popout-composer',
  properties: {
    action: 'clicked to open or close the popout composer',
    value
  }
});